import taoke_alipay_auth from '@/api/taoke_alipay_auth';
import { MessageBox, Message } from 'element-ui'

export default async function alipayAuth() {
  const action = await MessageBox.confirm('请使用发放款项的支付宝账号进行授权，授权后不可更改。', '注意', {type: 'warning'})
  if(action !== 'confirm') return Promise.reject()
  const {data} = await taoke_alipay_auth()
  if(data.error_code !== 0) {
    Message.error(data.error_message)
    return
  }

  const a = document.createElement('a')
  a.target = '_blank'
  a.href = data.gourl
  document.body.append(a)
  a.click()
  a.remove()
}
